export const VINFOOTERMENU = {
    help: {
        title: 'help',
        type: 'list',
        active: true,
        links: [
            {
                text: 'Mobile',
                url: 'http://beta.vin.com/mobile',
                display: false,
                target: '_blank'
            },
            {
                text: 'Help center',
                url: '/members/help/',
                display: true,
                target: 'blank'
            },
            {
                text: 'Feedback',
                url: 'javascript:master_header.ShowFeedback()',
                display: true,
                target: 'blank'
            },
            {
                text: 'feedback@vin.com',
                url: 'javascript:ShowFeedback();',
                display: false,
                target: 'blank'
            },
            {
                text: 'VIN Policies',
                url: '/Members/cms/project/default.aspx?id=473',
                display: true,
                target: 'blank'
            },
            {
                text: 'Contact Us',
                url: 'javascript:ShowFeedback();',
                display: false,
                target: 'blank'
            },
            {
                text: ' | Site Map',
                url: '/Members/Document.plx?Page=Sitemap',
                display: false,
                target: 'blank'
            },
        ],
    },
    requestToUse: {
        title: 'request to use',
        type: 'list',
        active: true,
        links: [
            {
                text: 'VIN content',
                url: '/doc/?id=9749120&pid=473',
                display: true,
                target: '_blank'
            },
            {
                text: 'Message board content',
                url: '/Members/cms/project/DefaultAdv1.aspx?pId=473&catId=2232&id=4732871&ind=7&objTypeID=10#Section1_3',
                display: true,
                target: 'blank'
            },
            {
                text: 'IVALA 3D content',
                url: '/members/cms/project/defaultadv1.aspx?id=9749120&pid=473',
                display: true,
                target: 'blank'
            },
            {
                text: 'Veterinary Partner content',
                url: 'https://veterinarypartner.vin.com/default.aspx?pid=19239&id=8523918',
                display: true,
                target: 'blank'
            }
        ],
    },
    contact: {
        title: 'contact us',
        type: 'para',
        active: true,
        links: [
            {
                text: '777 W. Covell Blvd., Davis, CA 95616',
                url: null,
                display: true,
                target: null
            },
            {
                text: 'vingram@vin.com',
                url: 'mailto:vingram@vin.com',
                display: true,
                target: 'blank'
            },
        ],
    },
    phone: {
        title: 'phone',
        type: 'list',
        active: false,
        links: [
            {
                text: '',
                url: '',
                display: false,
                target: 'blank'
            },
        ],
    },
    follow: {
        title: 'follow vin',
        type: 'social',
        active: false,
        links: [
            {
                text: '',
                url: '',
                display: false,
                target: 'blank'
            },
        ],
    },
};

export const VSPNFOOTERMENU = {
    siteMap: {
        title: 'site map',
        type: 'list',
        active: true,
        links: [
            {
                text: 'Front Page',
                url: '/members/cms/project/defaultadv1.aspx?pid=24054',
                display: true,
                target: 'blank'
            },
            {
                text: 'Message Boards',
                url: '/members/boards/?SAId=2',
                display: true,
                target: 'blank'
            },
            {
                text: 'Rounds',
                url: '/members/cms/project/defaultadv1.aspx?pId=8002&id=6040307&said=2',
                display: true,
                target: 'blank'
            },
            {
                text: 'Library',
                url: '/members/cms/project/defaultadv1.aspx?pid=6444&said=2',
                display: true,
                target: 'blank'
            },
            {
                text: 'CE',
                url: '/ce',
                display: true,
                target: 'blank'
            },
            {
                text: 'MyVSPN',
                url: 'javascript:master_header.ShowMyVIN();',
                display: true,
                target: null
            },
            {
                text: 'Help',
                url: '/members/cms/Project/DefaultAdv1.aspx?pid=30&id=2993083',
                display: true,
                target: 'blank'
            },
        ],
    },
    help: {
        title: 'help',
        type: 'list',
        active: false,
        links: [
            {
                text: 'Mobile',
                url: 'http://beta.vin.com/mobile',
                display: true,
                target: '_blank'
            },
            {
                text: 'Help center',
                url: '/members/help/',
                display: true,
                target: 'blank'
            },
            {
                text: 'feedback@vin.com',
                url: 'javascript:ShowFeedback();',
                display: false,
                target: 'blank'
            },
            {
                text: 'Feedback',
                url: 'javascript:master_header.ShowFeedback()',
                display: true,
                target: 'blank'
            },
            {
                text: 'Contact Us',
                url: 'javascript:ShowFeedback();',
                display: false,
                target: 'blank'
            },
            {
                text: 'VIN Policies',
                url: '/Members/cms/project/default.aspx?id=473',
                display: true,
                target: 'blank'
            },
            {
                text: ' | Site Map',
                url: '/Members/Document.plx?Page=Sitemap',
                display: false,
                target: 'blank'
            },
        ],
    },
    contact: {
        title: 'contact us',
        type: 'para',
        active: true,
        links: [
            {
                text: '777 W. Covell Blvd., Davis, CA 95616',
                url: null,
                display: true,
                target: null
            },
            {
                text: 'help@vspn.org',
                url: 'mailto:help@vspn.org',
                display: true,
                target: 'blank'
            },
        ],
    },
    phone: {
        title: 'phone',
        type: 'list',
        active: false,
        links: [
            {
                text: '',
                url: '',
                display: true,
                target: 'blank'
            },
        ],
    },
    follow: {
        title: 'follow vin',
        type: 'social',
        active: false,
        links: [
            {
                text: '',
                url: '',
                display: true,
                target: 'blank'
            },
        ],
    },
};